module.exports = __webpack_public_path__ + "static/media/img1-2.9927812c.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/nutricheck_suelo/B/img1-2.png
// module id = 1196
// module chunks = 3